import bpCardData from '../constants/bp-cards.json';

interface BPCard {
    level: string;
    usedFor: string;
    value: number;
}

const allBPCards = bpCardData as BPCard[];

// Bundled BP card data occasionally uses a different display name than the primordial list.
// Keep lookup aliases here so the calculator continues to work without duplicating BP rows.
const BP_PRIMORDIAL_NAME_ALIASES: Record<string, string[]> = {
    'Sun Descendant': ['Sun Descendent'],
    'Old Haunt': ['Old Haunt', 'Pitiless'],
};

function getBPPrimordialLookupNames(primordialName: string): string[] {
    return BP_PRIMORDIAL_NAME_ALIASES[primordialName] ?? [primordialName];
}

export function getBPAtValues(primordialName: string, bpLevel: string): number[] {
    const lookupNames = new Set(getBPPrimordialLookupNames(primordialName));

    return allBPCards
        .filter((card) => lookupNames.has(card.usedFor) && card.level === bpLevel)
        .map((card) => card.value)
        .sort((a, b) => a - b);
}

export function getAverageBPAtValue(primordialName: string, bpLevel: string): number | null {
    const values = getBPAtValues(primordialName, bpLevel);
    if (values.length === 0) return null;
    return Math.ceil(values.reduce((acc, value) => acc + value, 0) / values.length);
}

export function getAdjustedATValues(primordialName: string, bpLevel: string, atBonus: number): number[] {
    return getBPAtValues(primordialName, bpLevel).map((value) => Math.max(1, value + atBonus));
}

export function getRepresentativeATValue(values: number[]): number | null {
    if (values.length === 0) return null;
    return Math.ceil(values.reduce((acc, value) => acc + value, 0) / values.length);
}

export function getATRangeLabel(values: number[]): string | null {
    if (values.length === 0) return null;
    if (values.length === 1) return `${values[0]}`;
    return `${values[0]}-${values[values.length - 1]}`;
}
